import React, { Component } from 'react';
import Media from "react-media";
import moment from 'moment-timezone';
import { Link } from 'react-router-dom';
import { SCREEN_WIDTH } from '../../App.js';
import { translate } from 'react-i18next';
import brandLogo from '../../images/Portada_ios.png';

class Conecctions extends Component {
    getConecctionsLink = (conecctions) => {
        return {
            pathname: "/user/" + conecctions,
            state: {
                center: JSON.stringify(this.props.center),
                conecctions: JSON.stringify(conecctions)
            }
        };
    }

    renderConecctions = (conecctions, index) => {
        const { t } = this.props;
        const profile = conecctions.foto ? "https://img.iosoffices.com/img/iosfera/usuarios/" + conecctions.foto
            : "https://img.iosoffices.com/img/iosfera/usuarios/default.jpg";
        const portada = conecctions.portada ? "https://img.iosoffices.com/img/iosfera/portadas/" + conecctions.portada
            : brandLogo
        return (
            <div className="col-xl-12 col-lg-12 col-md-6 col-sm-6 col-6 card-panel-conecctions" key={index}>
                <div className="container-profile">
                    <div className="container-room-header card-panel panel panel-default card">
                        <div className="panel-heading card-panel-heading" style={{ backgroundImage: "url('" + portada + "')" }}>
                        </div>
                        <div className="card-panel-body">
                            <div className="profile">
                                <div className="badge-wrapper">
                                    <img
                                        className="cover-img__image relative w-full h-full object-cover img-responsive"
                                        alt={t('dashboard.profile.img_user')}
                                        src={profile}
                                        loading="lazy" data-embed-id="cover-image" />
                                </div>
                            </div>
                            <div className="profile-description">
                                <div className="user-data">
                                    <h4 className="iosname">{conecctions.nombre + " " + conecctions.apellido} {conecctions.id ? "#" + conecctions.id : null}<br></br></h4>
                                    <h4 className="iospuesto">{conecctions.puesto ? conecctions.puesto : null} </h4>
                                    <h4 className="ioswork">{conecctions.empresa ? conecctions.empresa : null} </h4>
                                </div>
                            </div>
                            <div className="profile-description user-description">
                                {conecctions.descripcion}
                            </div>
                        </div>
                        <div className="panel-body-bottom">
                            <div className="panel-body form-group">
                                <Link to={'/user/' + conecctions.id}>
                                    <button
                                        className="btn btn-block btn-primary btn-singup btn_create"
                                        type="button">
                                        {t('guest.benefits.btn_info')}
                                    </button>
                                </Link>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }

    render() {
        const conecctions = this.props.MyConecctions;
        return (
            <div className="list-card-conecctions">
                <div className="list-card-panel-seccion">
                    <div className="content-card-panel-seccion">
                        <Media query={"(min-width: " + SCREEN_WIDTH.LARGE + "px)"}>
                            {(matches) =>
                                matches ? (
                                    conecctions.map((_, index) => !(index % 2) &&
                                        <div className="row list" key={index}>
                                            {this.renderConecctions(conecctions[index], index)}
                                            {conecctions[index + 1] && this.renderConecctions(conecctions[index + 1], index + 1)}
                                        </div>
                                    )
                                ) : (
                                    conecctions.map((_, index) => !(index % 2) &&
                                        <div className="row list" key={index}>
                                            {this.renderConecctions(conecctions[index], index)}
                                            {conecctions[index + 1] && this.renderConecctions(conecctions[index + 1], index + 1)}
                                        </div>
                                    )
                                )
                            }
                        </Media>
                    </div>
                </div>
            </div>
        );
    }
}

export default translate('common')(Conecctions);


// WEBPACK FOOTER //
// ./src/dashboard/myConecctions/MyConecctions.js